import { IpAssignment, IpAssignmentFormData } from 'data/ipAssignment/ipAssignment.types';
import { Operation, WithAuditDetails, AuditDetails } from 'data/types';
import {
  getAuditDetails,
  getAuditFieldInfo,
  AuditService,
  AuditActionType,
} from 'shared/userAudit/audit-constants';

export default function getIpAssignmentDataToSubmit(
  ipAssignmentFormData: IpAssignmentFormData,
  isAuditEnabled: boolean,
  userId: string,
  userName: string,
  operation: Operation,
  ): WithAuditDetails<IpAssignment> {
  const ipAssignmentBody: WithAuditDetails<IpAssignment> = {
    data: ipAssignmentFormData,
  };

  let actionType = AuditActionType.IP_ASSIGNMENT_EDIT;
  let isEdit = false;
  if (operation === 'UPDATE') {
    actionType = AuditActionType.IP_ASSIGNMENT_EDIT;
    isEdit = true;
  }

  if (isAuditEnabled) {
    const auditDetails = getAuditDetails(
      isAuditEnabled,
      userId,
      userName,
      getAuditFieldInfo(ipAssignmentFormData, null, isEdit),
      '',
      AuditService.AF,
      actionType,
    );
    ipAssignmentBody.auditDetails = auditDetails as AuditDetails;
  }

  return ipAssignmentBody;
}
